import { ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types.d';

export const useGetImageUri = () => {
  const getLowResUri = (image: ImageDocumentStoreItem): string => {
    return (image?.isCropped ? image?.url : image?.originUrl3x) ?? '';
  };

  const getHighResUri = (image: ImageDocumentStoreItem): string => {
    return image?.urlZoom ?? '';
  };

  return {
    getHighResUri,
    getLowResUri,
  };
};
